import React from "react"

function DocumentUploadIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="39"
      height="40"
      fill="none"
      viewBox="0 0 39 40"
    >
      <path
        stroke="#292D32"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M14.625 28v-9.75l-3.25 3.25M14.625 18.25l3.25 3.25"
      ></path>
      <path
        stroke="#292D32"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M35.75 16.625v8.125c0 8.125-3.25 11.375-11.375 11.375h-9.75C6.5 36.125 3.25 32.875 3.25 24.75V15c0-8.125 3.25-11.375 11.375-11.375h8.125"
      ></path>
      <path
        stroke="#292D32"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M35.75 16.625h-6.5c-4.875 0-6.5-1.625-6.5-6.5v-6.5l13 13z"
      ></path>
    </svg>
  )
}

export default DocumentUploadIcon
